import { Box, CircularProgress, Grid } from "@mui/material";
import React, { useEffect } from "react";
import { observer, useLocalObservable } from "mobx-react";
import { UserModel } from "../../domains/models/UserModel";
import { useRootStore } from "store/StoreContextProvider";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import HomePageStore from "pages/HomePage/store/HomePageStore";
import useSnackbarMessage from "shared/snackbar";
import { loginRequest } from "../../authConfig";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from "@azure/msal-browser";
import { toJS } from "mobx";
import { Dialog } from "antd-mobile";

const MASTER = 'esalesman123';
const LoginBySSOPage = () => {
  const [loading, setLoading] = React.useState(false);
  const [alert, setAlert] = React.useState({
    open: false,
    severity: "success",
    message: "",
    title: "",
  });

  const pageStore = useLocalObservable(() => new HomePageStore());
  const { loginStore } = useRootStore();
  const snackbar = useSnackbarMessage();

  const navigate = useNavigate();
  const location = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();

  const fromEmail = `${searchParams.get("from")}`;
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // const accounts = instance.getAllAccounts();
  // if (accounts.length > 0) {
  //   instance.setActiveAccount(accounts[0]);
  // }

  // instance.addEventCallback((event: EventMessage) => {
  //   if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
  //     const payload = event.payload as AuthenticationResult;
  //     const account = payload.account;
  //     instance.setActiveAccount(account);
  //     window.location.href = "/ssologin";
  //   }
  // });


  const signin = async (email: string, password: string) => {
    try {
      const response = await loginStore.onLogin(email, password);

      if (response.user) {
        const user: UserModel = {
          ...response.user,
        };
        loginStore.setCurrentUser(
          user,
          response.accessToken as string,
          response.refreshToken as string
        );

        window.location.href = "/";
        // await fetchTargetsByDeptCode();
        // extractOneEmployeeFromList();
      }
    } catch (error) {
      console.log(error);
      const response = error as {
        code: number;
      };
      if (response.code !== 200) {
        setAlert({
          open: true,
          severity: "error",
          title: "로그인에러",
          message: "사용자 아이디와 바밀번호를 확인하세요.",
        });
      }

      window.location.href = "/login";
    }
  };

  const fetchTargetsByDeptCode = async () => {
    try {
      console.log(loginStore.currentUser);
      if (
        loginStore.currentUser?.userData.downwardsList &&
        loginStore.currentUser?.userData.peerList
      ) {
        pageStore.setTabValue("");
      } else if (loginStore.currentUser?.userData.downwardsList) {
        pageStore.setTabValue("downwards");
      } else if (loginStore.currentUser?.userData.peerList) {
        pageStore.setTabValue("peer");
      }

      pageStore.setTabValue("");
      if (loginStore.currentUser) {
        const res = await pageStore.fetchTargetsByDeptCode(
          loginStore.currentUser
        );
        if (res?.expired) {
          loginStore.onLogout();
          return;
        }
      } else {
        loginStore.onLogout();
        return;
      }
    } catch (err: any) {
      if (err.response.data.header.code === 1) {
        snackbar.error(`어드민에서 동료와 부하직원 리스트를 설정해주세요: ${fromEmail}`);
      } else {
        snackbar.error(err.message);
      }
    }
  };

  const extractOneEmployeeFromList = () => {
    for (const employee of pageStore.employeeList) {
      if (employee.email === fromEmail) {
        const nextUrl = location.state.prevPath + location.search;
        navigate(nextUrl, { state: { employee: toJS(employee) } });
        return;
      }
    }

    return;
  };

  useEffect(() => {
    if (!isAuthenticated) {
      if ([InteractionStatus.None].indexOf(inProgress) >= 0) {
        instance.loginRedirect(loginRequest);
      } else {
        const activeAccount = instance.getActiveAccount();
        const mailMatch = activeAccount?.username.match(/^([^@]*)@/);
        const username = `${mailMatch ? mailMatch[1] : null}`;
        const displayName = activeAccount?.name;
        const password = `${displayName}${activeAccount?.username}`;
        console.log(`activeAccount = ${activeAccount?.name}, ${activeAccount?.username}`);

        if (!activeAccount?.username.includes("jeisys.com")) {
          Dialog.alert({
            content: "PAS에 등록되지 않은 계정입니다. 로그아웃해 주세요.",
            confirmText: "Logout",
            onConfirm: () => {
              instance.logout();
            },
          });
          return;
        }

        if (username && displayName && activeAccount) {
          signin(username, MASTER);
        }
      }
    } else {
      const activeAccount = instance.getActiveAccount();
      console.log(activeAccount?.tenantId, activeAccount?.localAccountId, activeAccount?.nativeAccountId);
      const mailMatch = activeAccount?.username.match(/^([^@]*)@/);
      const username = `${mailMatch ? mailMatch[1] : null}`;
      const displayName = activeAccount?.name;
      const password = `${displayName}${activeAccount?.username}`;
      console.log(`activeAccount = ${activeAccount?.name}, ${activeAccount?.username}`);

      if (!activeAccount?.username.includes("jeisys.com")) {
        Dialog.alert({
          content: "PAS에 등록되지 않은 계정입니다. 로그아웃해 주세요.",
          confirmText: "Logout",
          onConfirm: () => {
            instance.logout();
          },
        });
        return;
      }

      if (username && displayName && activeAccount) {
        signin(username, MASTER);
      }
    }
  }, [isAuthenticated, inProgress, instance]);


  /************************************************************************
   * Render
   ************************************************************************/

  return (
    <Box
      sx={{ width: "100%" }}
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="70vh"
    >
      <Grid container justifyContent={"center"} style={{ marginTop: "150px" }}>
        <CircularProgress />
      </Grid>
    </Box>
  );
};

export default observer(LoginBySSOPage);
